import { styled, css, Box, Flex, Popover, StyleSystemProps } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';
import { PopoverProps } from '@withjoy/joykit/components/PopoverV1/types';

export const StyledPopover = styled(Popover)``;
const popoverContentProps: PopoverProps['contentProps'] = {
  borderRadius: 'inherit',
  boxShadow: '0px 30px 60px rgba(68, 50, 93, 0.05), 0px 18px 36px rgba(0, 0, 0, 0.06)',
  backgroundColor: 'unset',
  backdropFilter: 'saturate(180%) blur(8px)',
};
const popoverTransitionElProps: PopoverProps['transitionElProps'] = {
  background: 'rgba(255, 255, 255, 0.9)',
  borderRadius: 4,
};

export const StyledPillContainer = styled(Flex)<{ $isWidgetOpen: boolean }>`
  svg {
    transition: ${animationTransition('transform')};
    ${({ $isWidgetOpen }) => {
      return {
        transform: `rotate(${$isWidgetOpen ? '-180deg' : '0deg'})`,
      };
    }}
  }
`;
const pillContainerStyles: StyleSystemProps = {
  cursor: 'pointer',
  border: '1px solid',
  borderColor: 'gray3',
  alignItems: 'center',
  borderRadius: 24,
  backgroundColor: 'white',
  padding: 1,
};

const avatarWithFallbackMixin = css<{ $initials?: string; $avatarUrl?: string }>`
  ${({ $initials, $avatarUrl }) => {
    return $avatarUrl
      ? {
          backgroundImage: `url('${$avatarUrl}')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }
      : $initials
      ? {
          '::after': {
            content: `'${$initials}'`,
            display: 'block',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          },
        }
      : {};
  }}
`;

export const StyledAvatarWithFallback = styled(Box)<{ $initials?: string; $avatarUrl?: string }>`
  position: relative;
  border-radius: 100%;
  background-color: ${props => props.theme.colors.gray3};
  cursor: ${props => (props.onClick ? 'pointer' : undefined)};
  ${avatarWithFallbackMixin}
`;

export const styles = {
  pillContainer: pillContainerStyles,
  popoverContentProps,
  popoverTransitionElProps,
};
